@charset "UTF-8";

/* src/app/email-campaign/edit-panel/edit-panel.component.scss */
.margin-auto {
  margin: auto !important;
}
.wc-my-auto {
  margin-bottom: auto !important;
  margin-top: auto !important;
}
.ml--1 {
  margin-left: -1px;
}
.ml--2 {
  margin-left: -2px;
}
.ml--3 {
  margin-left: -3px;
}
.ml--4 {
  margin-left: -4px;
}
.ml--5 {
  margin-left: -5px;
}
.ml--6 {
  margin-left: -6px;
}
.ml--7 {
  margin-left: -7px;
}
.ml--8 {
  margin-left: -8px;
}
.ml--9 {
  margin-left: -9px;
}
.ml--10 {
  margin-left: -10px;
}
.ml--15 {
  margin-left: -15px;
}
.mr--5 {
  margin-right: -5px;
}
.mr--10 {
  margin-right: -10px;
}
.mr--15 {
  margin-right: -15px;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.mr-0 {
  margin-right: 0 !important;
}
.m-1 {
  margin: 5px !important;
}
.my-1 {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.mx-1 {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.mt-1 {
  margin-top: 5px !important;
}
.mb-1 {
  margin-bottom: 5px !important;
}
.ml-1 {
  margin-left: 5px !important;
}
.mr-1 {
  margin-right: 5px !important;
}
.mb-1-5 {
  margin-bottom: 7.5px !important;
}
.m-2 {
  margin: 10px !important;
}
.my-2 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.mx-2 {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.mt-2 {
  margin-top: 10px !important;
}
.mb-2 {
  margin-bottom: 10px !important;
}
.ml-2 {
  margin-left: 10px !important;
}
.mr-2 {
  margin-right: 10px !important;
}
.m-3 {
  margin: 15px !important;
}
.my-3 {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}
.mx-3 {
  margin-left: 15px !important;
  margin-right: 15px !important;
}
.mt-3 {
  margin-top: 15px !important;
}
.mb-3 {
  margin-bottom: 15px !important;
}
.ml-3 {
  margin-left: 15px !important;
}
.mr-3 {
  margin-right: 15px !important;
}
.m-4 {
  margin: 20px !important;
}
.my-4 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.mx-4 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
.mt-4 {
  margin-top: 20px !important;
}
.mb-4 {
  margin-bottom: 20px !important;
}
.ml-4 {
  margin-left: 20px !important;
}
.mr-4 {
  margin-right: 20px !important;
}
.m-5 {
  margin: 25px !important;
}
.my-5 {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}
.mx-5 {
  margin-left: 25px !important;
  margin-right: 25px !important;
}
.mt-5 {
  margin-top: 25px !important;
}
.mb-5 {
  margin-bottom: 25px !important;
}
.ml-5 {
  margin-left: 25px !important;
}
.mr-5 {
  margin-right: 25px !important;
}
.m-6 {
  margin: 30px !important;
}
.my-6 {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}
.mx-6 {
  margin-left: 30px !important;
  margin-right: 30px !important;
}
.mt-6 {
  margin-top: 30px !important;
}
.mb-6 {
  margin-bottom: 30px !important;
}
.ml-6 {
  margin-left: 30px !important;
}
.mr-6 {
  margin-right: 30px !important;
}
.mb-8 {
  margin-bottom: 40px !important;
}
.p-0 {
  padding: 0 !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pr-0 {
  padding-right: 0 !important;
}
.p-1 {
  padding: 5px !important;
}
.py-1 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.px-1 {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.pt-1 {
  padding-top: 5px !important;
}
.pb-1 {
  padding-bottom: 5px !important;
}
.pl-1 {
  padding-left: 5px !important;
}
.pr-1 {
  padding-right: 5px !important;
}
.p-2 {
  padding: 10px !important;
}
.py-2 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.px-2 {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.pt-2 {
  padding-top: 10px !important;
}
.pb-2 {
  padding-bottom: 10px !important;
}
.pl-2 {
  padding-left: 10px !important;
}
.pr-2 {
  padding-right: 10px !important;
}
.p-3 {
  padding: 15px !important;
}
.py-3 {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.px-3 {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.pt-3 {
  padding-top: 15px !important;
}
.pb-3 {
  padding-bottom: 15px !important;
}
.pl-3 {
  padding-left: 15px !important;
}
.pr-3 {
  padding-right: 15px !important;
}
.p-4 {
  padding: 20px !important;
}
.py-4 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.px-4 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.pt-4 {
  padding-top: 20px !important;
}
.pb-4 {
  padding-bottom: 20px !important;
}
.pl-4 {
  padding-left: 20px !important;
}
.pr-4 {
  padding-right: 20px !important;
}
.p-5 {
  padding: 25px !important;
}
.py-5 {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}
.px-5 {
  padding-left: 25px !important;
  padding-right: 25px !important;
}
.pt-5 {
  padding-top: 25px !important;
}
.pb-5 {
  padding-bottom: 25px !important;
}
.pl-5 {
  padding-left: 25px !important;
}
.pr-5 {
  padding-right: 25px !important;
}
.p-6 {
  padding: 30px !important;
}
.py-6 {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
.px-6 {
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.pt-6 {
  padding-top: 30px !important;
}
.pb-6 {
  padding-bottom: 30px !important;
}
.pl-6 {
  padding-left: 30px !important;
}
.pr-6 {
  padding-right: 30px !important;
}
.px-7 {
  padding-left: 35px !important;
  padding-right: 35px !important;
}
.py-7 {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}
.pb-7 {
  padding-bottom: 35px !important;
}
.px-8 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
.py-8 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.pb-8 {
  padding-bottom: 40px !important;
}
.pt-8 {
  padding-top: 40px !important;
}
.text-justify {
  text-align: justify !important;
}
.text-wrap {
  white-space: normal !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-lighter {
  font-weight: lighter !important;
}
.font-weight-normal {
  font-weight: 400 !important;
}
.font-weight-500 {
  font-weight: 500 !important;
}
.font-weight-600 {
  font-weight: 600 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-bolder {
  font-weight: bolder !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  display: block;
  color: #000;
}
.text-blue {
  color: #2e93a1 !important;
}
.text-green {
  color: #229300;
}
.text-danger {
  color: #DE0000;
}
.text-defualt {
  color: #484b59;
  font-weight: 100;
}
.gray-text {
  color: #777777;
}
.text-light-grey {
  color: #949494 !important;
}
.text-white {
  color: #fff;
}
.text-black {
  color: #484b59 !important;
}
.text-orange {
  color: #FF9B05 !important;
}
.text-pink {
  color: #e85d75;
}
.text-dis {
  color: #CCCCCC;
}
.text-light-blue {
  color: #8fdde4;
}
.text-light-orange {
  color: #ffcd82;
}
.text-light-purple {
  color: #d6bdff;
}
.text-6767 {
  color: #676767;
}
.text-warning {
  color: #FFC400 !important;
}
a {
  color: #4dc7f4;
  outline: none;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  cursor: pointer;
  color: #4dc7f4;
}
.spacer {
  width: 1px;
  height: 1px;
}
.spacer2 {
  width: 1px;
}
.wc-d-block {
  display: block;
}
.wc-d-inline {
  display: inline;
}
.wc-d-inline-block {
  display: inline-block;
}
.wc-label {
  display: block;
  font-size: 14px;
  color: #000;
  padding-bottom: 5px;
}
.wc-form-control {
  border-radius: 2px;
  border: 2px solid #d6dde6;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 12px;
  height: 36px;
  width: 100%;
}
.wc-form-control:focus {
  border-color: #2e93a1;
  outline: none;
}
.wc-textarea {
  height: 100%;
}
.hr-color {
  border-bottom: 1px solid #676767;
}
.hr-color .wc-hr {
  display: inline;
}
.w-100 {
  width: 100%;
}
.h-15 {
  height: 18px;
}
.f-8 {
  font-size: 8px;
  line-height: 1.3;
}
.f-10 {
  font-size: 10px;
  line-height: 1.3;
}
.f-11 {
  font-size: 11px;
  line-height: 1.3;
}
.f-12 {
  font-size: 12px;
  line-height: 1.3;
}
.f-16 {
  font-size: 16px;
  line-height: 1.3;
}
.f-14 {
  font-size: 14px;
  line-height: 1.3;
}
.f-18 {
  font-size: 18px;
  line-height: 1.3;
}
.f-20 {
  font-size: 20px;
  line-height: 1.3;
}
.f-22 {
  font-size: 22px;
  line-height: 1.3;
}
.f-24 {
  font-size: 24px;
  line-height: 1.3;
}
.f-26 {
  font-size: 26px;
  line-height: 1.3;
}
.f-28 {
  font-size: 28px;
  line-height: 1.3;
}
.f-30 {
  font-size: 30px;
  line-height: 1.3;
}
.f-32 {
  font-size: 32px;
  line-height: 1.3;
}
.sep-tag {
  color: #676767;
  font-weight: 500;
  padding-bottom: 15px;
  background-color: #fff;
}
.category {
  color: #949494;
  font-weight: 500;
}
.wc-select {
  background-color: #fff;
  color: #676767;
}
.wc-select option {
  color: #484b59;
}
.wc-select option:disabled {
  color: #676767;
}
.wc-float-right {
  float: right;
}
.wc-float-left {
  float: left;
}
.wc-sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  z-index: 1020;
  padding-top: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  transition: all 0.3s;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.wc-upload-btn {
  width: 100px;
  height: 100px;
  border: 1px solid #777777;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  background-color: white;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.wc-upload-btn i {
  font-size: 16px;
  color: #2e93a1;
  position: relative;
  top: 45px;
  color: #2e93a1;
}
.wc-upload-btn .upload-sign {
  position: relative;
  top: 48px;
}
.wc-upload-btn input {
  position: absolute;
  cursor: pointer;
  font-size: 50px;
  opacity: 0;
  right: 0;
  top: 0;
}
.b {
  border: none;
}
.bl,
.bx {
  border-left: none;
}
.br,
.bx {
  border-right: none;
}
.bt,
.by {
  border-top: none;
}
.bb,
.by {
  border-bottom: none;
}
.wc-border {
  border: 1px solid #d1d1d1;
}
.wc-gray-border {
  border: 1px solid #484b59;
}
.br-0 {
  border-radius: inherit !important;
}
.brr-0 {
  border-top-right-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.brl-0 {
  border-top-left-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
}
.brt-0 {
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
}
.brb-0 {
  border-bottom-left-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 16px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: white;
  border: 2px solid #777777;
  box-sizing: border-box;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: -1px;
  bottom: 0px;
  background-color: #777777;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: white;
  border-color: #80d7f8;
}
input:focus + .slider {
  box-shadow: 0 0 1px #80d7f8;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  left: -10px;
  margin-right: -4px;
  background-color: #80d7f8;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.forms-top-header {
  width: calc(100% - 145px);
  position: fixed;
  top: 60px;
  margin: 0;
  padding: 20px 0 20px 0;
  background-color: #fff;
  z-index: 2;
}
.main-form {
  position: relative;
  top: 100px;
}
.wc-btn:hover {
  color: #ffffff;
  background-color: #206C79;
}
.wc-btn:focus {
  outline: none;
}
.wc-btn {
  padding: 7px 21px;
  color: #ffffff;
  font-weight: 100;
  border-radius: 2px;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-xs {
  padding: 3px 20px;
  border-radius: 16px;
  color: #ffffff;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-validate {
  background-color: #4a90e2;
}
.wc-btn-registered {
  background-color: #ffcd82;
}
.wc-primary {
  background-color: #2e93a1;
}
.wc-gray-btn {
  background-color: #999999;
}
.wc-white-btn {
  background-color: #fff;
  color: #484b59;
  border: 2px solid #d6dde6 !important;
}
.wc-primary {
  background-color: #2e93a1;
}
.line-height-1 {
  line-height: 1.6;
}
.line-height {
  line-height: 0px;
}
.hc {
  color: #484b59;
}
.bg-blue {
  background-color: #2E93A1;
}
.bg-blue-light {
  background-color: #b3e7fa;
}
.bg-blue-dark {
  background-color: #4a90e2;
}
.bg-blue-2 {
  background-color: #8fdde4;
}
.bg-orange {
  background-color: #FF9B05;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-gray {
  background-color: #fafafc !important;
}
.bg-gray-dark-2 {
  background-color: #d6dde6;
}
.bg-gray-dark {
  background-color: #d1d1d1;
}
.bg-gray-light {
  background-color: #fafafc;
}
.bg-red-light {
  background-color: #ead1d2;
}
.bg-red {
  background-color: #DE0000;
}
.bg-white {
  background-color: #ffffff;
}
.bg-green {
  background-color: #229300;
}
.bg-brawn {
  background-color: #cbaea5;
}
.bg-black {
  background-color: #484b59;
}
.nobg {
  background-color: transparent;
}
.btn-bg-black {
  background-color: #334059;
}
.btn-interview {
  padding: 8px 15px;
  letter-spacing: 4;
  color: #586e9a;
  border-radius: 2px;
  border: solid 1px #586e9a;
  transition: all 0.5s;
  background-color: #ffffff;
}
.btn-interview:hover,
.btn-interview:active,
.btn-interview:focus {
  color: #ffffff;
  border: solid 1px #586e9a;
  background-color: #586e9a;
}
.red-border {
  border: 1px solid #DE0000;
}
.blue-border {
  border: 1px solid #2e93a1;
}
.black-border {
  border: solid 1px #2C2C2C;
}
.border-stepper {
  border: solid 1px #334059;
}
.step-gray-border {
  border: solid 1px #d1d1d1;
}
.gt {
  color: #999999;
}
.text-blue-gray {
  color: #8094B1;
}
.light-blue-text {
  color: #012964;
}
.black-text {
  color: #000;
}
.green-text {
  color: #4ac98d;
}
.wccard {
  border-radius: 2px;
  background-color: #fff;
}
.wc-border {
  border: 2px solid #ECF0F4;
}
.wc-bl {
  border-left: 2px solid #ECF0F4;
}
.wc-br {
  border-right: 2px solid #ECF0F4;
}
.wc-bt {
  border-top: 2px solid #ECF0F4;
}
.wc-bb {
  border-bottom: 2px solid #ECF0F4;
}
.bg-warning {
  background-color: #FFC400;
}
.bg-light-green {
  background-color: #d3e9cc;
}
.bg-light-red {
  background-color: rgba(222, 0, 0, 0.2);
}
.paused-color {
  background-color: #FFF3CC;
}
.bg-img {
  background-color: #f5f6f9;
}
.hrcolor {
  border-top: 1px solid #ECF0F4;
}
.z-1 {
  z-index: -1;
}
.z0 {
  z-index: 0;
}
.z1 {
  z-index: 1;
}
.z2 {
  z-index: 2;
}
.z3 {
  z-index: 3;
}
.z4 {
  z-index: 4;
}
.z5 {
  z-index: 5;
}
.wc-box-shadow {
  box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
}
.pointer {
  cursor: pointer;
}
.c-logo {
  width: 50px;
  height: 50px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-mini {
  width: 30px;
  height: 30px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo-mini img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md {
  width: 80px;
  height: 80px;
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
}
.c-logo-md img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md i {
  font-size: 40px;
}
.showpassword {
  position: absolute;
  top: 10px;
  right: 4%;
}
.listStyleBullet > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.listStyleBullet > ul li {
  padding: 2px 0;
}
.listStyleBullet div > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.strikethrough {
  text-decoration: line-through;
  color: #999999;
}
.anchor-text {
  color: #4dc7f4 !important;
}
.tl0 {
  top: 0;
  left: 0;
}
.tr0 {
  top: 0;
  right: 0;
}
.ats-cta-btn:hover i {
  color: #206C79;
}
.ats-cta-btn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: #D5E9EC;
  padding: 5px 8px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ats-cta-btn i {
  color: #2E93A1;
  font-size: 14px;
  font-weight: 600;
}
.wc-progress-profile {
  background-color: rgba(103, 198, 187, 0.2);
  border-radius: 1rem;
}
.wc-progress-profile .wc-progress-bar {
  background-color: rgb(103, 198, 187);
}
.mt-3px {
  margin-top: 3px;
}
.mb-3px {
  margin-bottom: 1px;
}
label {
  font-size: 12px;
}
.no-outline {
  outline: none;
}
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  display: none;
}
.text-484b59 {
  color: #484b59;
}
.yrofexp {
  width: 160px;
  float: left;
}
.yrofexp input[type=number] {
  width: 60px;
  float: left;
  z-index: 2;
  position: relative;
  font-size: 14px;
}
.yrofexp input[type=text] {
  width: 90px;
  float: left;
  z-index: 2;
  margin-left: -2px;
  text-align: center;
}
.yrofexp input[type=text]:focus {
  border: 2px solid #d6dde6;
}
.yrofexp label {
  width: 100px;
  float: left;
  padding: 7.5px 12px;
  border: 2px solid #d6dde6;
  margin-left: -2px;
  border-radius: 0 2px 2px 0;
  color: #000;
  text-align: center;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
.form-control-sm::-webkit-inner-spin-button,
.form-control-sm::-webkit-outer-spin-button {
  -webkit-appearance: auto !important;
  appearance: auto !important;
  margin: 0;
}
.upload-container {
  width: 100%;
  float: left;
  height: 80px;
  color: #2e93a1;
  border: 2px solid #fafafc;
  cursor: pointer;
  position: relative;
  transition: 0.4s;
  border-radius: 2px;
}
.upload-container .upload--btn {
  width: 76px;
  height: 100%;
  padding: 22px 30px;
  background-color: #fafafc;
  font-size: 24px;
  position: absolute;
  transition: 0.4s;
  z-index: 2;
}
.upload-container .upload--section {
  width: 100%;
  text-align: left;
  position: absolute;
  left: 0;
  line-height: 76px;
  padding-left: 100px;
  transition: 0.4s;
  z-index: 0;
}
.upload-container input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.upload-container:hover {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
.upload-container:hover .upload--btn {
  background-color: #2e93a1;
  color: #fff;
  transition: 0.4s;
  z-index: 2;
}
.upload-container:hover .upload--section {
  background-color: #fafafc;
  color: #2e93a1;
  transition: 0.4s;
  z-index: 0;
}
.upload-container:focus {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
#b2bfd0 ::placeholder {
  color: red !important;
}
:-ms-input-placeholder {
  color: red !important;
}
::-ms-input-placeholder {
  color: red !important;
}
.genderBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.genderBtn .genderRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.genderBtn .genderText {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.genderBtn > input[type=radio]:checked + .genderText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  z-index: 2;
}
.wc-checkbox {
  width: 20px !important;
  height: 20px !important;
  position: relative;
  left: 0;
  top: 0;
  cursor: pointer;
}
.wc-checkbox input[type=checkbox] {
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
}
.wc-radioBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.wc-radioBtn .teamRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.wc-radioBtn .teamText {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.wc-radioBtn > input[type=radio]:checked + .teamText,
.wc-radioBtn > input[type=checkbox]:checked + .teamText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  cursor: pointer;
}
.wc-ghostBtn {
  padding: 7px 21px;
  border: 1px solid #969696;
  background-color: #fff;
  color: #484b59;
  transition: 0.5s;
  outline: none;
  border-radius: 3px;
}
.wc-ghostBtn:hover {
}
.wc-ghostBtn:focus {
  color: #2e93a1;
  background-color: #fff;
}
.wc-ghostdisabled {
  color: #999999;
  border: 2px solid #999999;
  background-color: #fff;
  outline: none;
}
.wc-ghostBtnRed {
  border: 2px solid #DE0000;
  background-color: #fff;
  color: #DE0000;
  transition: 0.5s;
  outline: none;
}
.wc-ghostBtnRed:hover {
  color: #fff;
  background-color: #DE0000;
}
.wc-ghostBtnRed:focus {
  color: #fff;
  background-color: #DE0000;
}
@media only screen and (max-width: 1440px) {
  .wc-checkbox {
    width: 25px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 30px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1170px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media (max-width: 768px) {
  .modal-dialog {
    max-width: 700px;
    margin: 1.75rem auto;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    max-width: 95%;
    margin: 1.75rem auto;
  }
}
@media only screen and (max-width: 768px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 576px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
.ats-upload-btn {
  width: 100%;
  border: dashed 0.5px #b0bed2;
  color: #484b59;
  display: flex;
  box-sizing: border-box;
  position: relative;
}
.ats-upload-btn span {
  color: #d1d1d1;
  font-size: 34px;
  line-height: 1;
  z-index: 0;
}
.ats-upload-btn .ats--upload-cv,
.ats-upload-btn .ats--upload-linkedin {
  width: 50%;
  float: left;
  padding: 20px;
  border-right: 1px dashed #b0bed2;
  box-sizing: border-box;
  z-index: 0;
}
.ats-upload-btn .ats--upload-linkedin {
  border-right: none;
}
.ats-upload-btn input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.social-check {
  position: relative;
  cursor: pointer;
  margin-right: 10px;
}
.social-check input[type=checkbox] {
  width: 15px;
  height: 15px;
  opacity: 0;
}
.social-check i {
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
  color: #b2bfd0;
  cursor: pointer;
  transition: 0.5s;
}
.social-check input[type=checkbox]:checked + i {
  transition: 0.5s;
  color: #2e93a1;
}
input[type=month]::-webkit-inner-spin-button {
  display: none;
}
input[type=month]::-webkit-calendar-picker-indicator {
  opacity: 0;
  z-index: 2;
}
div.uploadFile {
  position: relative;
}
div.uploadFile input[type=file] {
  width: 100%;
  padding: 6px 12px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 2;
}
div.uploadFile span {
  position: absolute;
  left: 12px;
  top: 7px;
  z-index: 0;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 93%;
  white-space: nowrap;
}
div.uploadFile span i {
  color: #b2bfd0;
  cursor: pointer;
}
.custom-control-label::before {
  background-color: #fff;
  border: #2e93a1 solid 1px;
}
.custom-control-label::after {
  background-color: #2e93a1;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2e93a1;
  background-color: #2e93a1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  -webkit-transform: translateX(0.75rem);
  transform: translateX(0.75rem);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #2e93a1;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(48, 5, 127, 0.4);
}
.wc-can-cta .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}
@media (max-width: 576px) {
  .ats-upload-btn {
    width: 100%;
    height: 100%;
    border: dashed 0.5px #b0bed2;
    color: #484b59;
    display: block;
    box-sizing: border-box;
    position: relative;
  }
  .ats-upload-btn span {
    color: #d1d1d1;
    font-size: 50px;
    line-height: 1;
    z-index: 0;
  }
  .ats-upload-btn .ats--upload-cv,
  .ats-upload-btn .ats--upload-linkedin {
    width: 100%;
    float: left;
    padding: 40px;
    border-right: 1px dashed #b0bed2;
    box-sizing: border-box;
    z-index: 0;
    display: block;
    border-bottom: 1px dashed #b0bed2;
  }
  .ats-upload-btn .ats--upload-linkedin {
    border-right: none;
    border-bottom: none;
  }
  .ats-upload-btn input {
    position: absolute;
    height: 100%;
    width: 100%;
    outline: none;
    cursor: pointer;
    opacity: 0;
    display: block;
  }
}
.bg-banner {
  background: url("./media/bg-image-ZQ6KMGTV.png");
  background-position: left top;
  background-size: cover;
  height: 100%;
}
.bg-banner .blueOverlay {
  position: absolute;
  opacity: 0.9;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 333;
  height: 100%;
}
.py-40 {
  padding-top: 45px;
}
.centeredForm {
  margin-top: 80px;
}
.logowidth {
  width: 45px;
  height: auto;
}
.wc-logotext {
  font-size: 30px;
  color: #fff;
}
.text-fafafa {
  color: #fafafa;
}
.iconDiv {
  width: 45px;
  float: left;
}
.textDiv {
  width: calc(100% - 45px);
  float: left;
}
.overlay {
  width: 100%;
  height: 80%;
  background-image:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgb(34, 53, 78));
  position: absolute;
  bottom: 0%;
}
.h100vh {
  height: 100vh;
}
#loginContainer {
  position: fixed;
  top: 0;
  left: 0;
}
@media only screen and (max-width: 600px) {
  .h100vh {
    height: 135vh;
  }
}
.logowidth {
  width: 35px;
  height: auto;
}
.wc-logotext {
  font-size: 22px;
  color: #FF9B05;
  vertical-align: -webkit-baseline-middle;
  line-height: 1;
  font-weight: 600;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: #F5F6F9;
}
.nav-link {
  display: block;
  padding: 0.5rem 2.5rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  font-weight: bold;
  background-color: #2e93a1;
}
.test {
  position: relative;
}
.test input[type=text] {
  background-color: transparent;
  z-index: 1;
}
.test .droparrow-down,
.test .droparrow-up {
  position: absolute;
  top: 9px;
  right: 15px;
  color: #d6dde6;
}
.test .fa-chevron-up {
  display: none;
}
input[type=text]:focus + .droparrow-down .fa-chevron-down {
  display: none;
  color: #2e93a1;
}
input[type=text]:focus + .droparrow-down .fa-chevron-up {
  display: block;
  color: #2e93a1;
}
.progress-c {
  width: 100px;
  height: 100px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
  border: 5px solid #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2e93a1;
  font-weight: bold;
}
.wc-linked-btn-1,
.wc-uplaodrsume-btn-1 {
  width: 45%;
  float: left;
  color: #008bc2;
  border: 2px solid #008bc2;
  border-radius: 2px;
  margin-left: 15px;
  cursor: pointer;
}
.wc-linked-btn-1 .wc-linked-btn-i,
.wc-linked-btn-1 .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1 .wc-linked-btn-i,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  padding: 8px 9px;
  display: inline-flex;
  border-right: 2px solid #008bc2;
  justify-content: center;
}
.wc-linked-btn-1 .wc-linked-btn-t,
.wc-linked-btn-1 .wc-uplaodrsume-btn-t,
.wc-uplaodrsume-btn-1 .wc-linked-btn-t,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-t {
  padding: 3px 10px;
  display: inline-flex;
  justify-content: center;
  width: calc(100% - 36px);
}
.wc-linked-btn-1:hover,
.wc-uplaodrsume-btn-1:hover {
  color: #ffffff;
  background: #008bc2;
  border: 2px solid transparent;
  transition: 0.5s;
}
.wc-linked-btn-1:hover .wc-linked-btn-i,
.wc-linked-btn-1:hover .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-linked-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-uplaodrsume-btn-i {
  border-right: 2px solid #fff;
  padding: 8px 9px;
}
.wc-uplaodrsume-btn-1 {
  position: relative;
  color: #84DA28;
  border: 2px solid #84DA28;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  border-right: 2px solid #84DA28;
}
.wc-uplaodrsume-btn-1 .resumeuplad {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .resumeuplad input[type=file] {
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1:hover {
  background: #84DA28;
}
button.close {
  outline: none;
}
input.wc-form-control:focus {
  z-index: 2;
}
.test input[type=text]:focus {
  z-index: 2;
}
.panel-heading {
  width: 100%;
  height: 45px;
  flex-grow: 0;
  margin: 0;
  padding: 12px 15px 12px 15px;
  background-color: #f6f6f6;
}
.edit-panel {
  width: 100%;
  position: absolute;
  right: -0.8rem;
  top: -0.8rem;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.editor {
  width: 828px;
  height: 286px;
  flex-grow: 0;
  margin: 5px 20px 20px;
  padding: 0 0 14px;
  border: solid 1px #d9d9d9;
}
.section {
  display: flex;
}
.sec {
  margin: 0 0 0 1rem;
  align-items: center;
  padding: 0;
}
.sec2 {
  margin: 0 1rem;
  align-items: center;
}
.sec-preview {
  margin: 10px 1rem;
  align-items: center;
}
.sec-preview-2 {
  margin: 10px 1rem;
  align-items: center;
}
.camp-name {
  width: 100%;
  height: 30px;
  flex-grow: 0;
  margin: 6px 0 0;
  padding: 6px 12px 6px 12px;
  border-radius: 2px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.templ-name {
  width: 562px;
  height: 30px;
  flex-grow: 0;
  margin: 6px 0 0;
  padding: 6px 12px;
  border-radius: 2px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.snd-after {
  width: 114px;
  height: 21px;
  flex-grow: 0;
  margin: 4px 20px 14px;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #484b59;
}
.hrs {
  width: 90px;
  height: 30px;
  flex-grow: 0;
  margin: 0 12px 0 12px;
  padding-left: 2px;
  border-radius: 4px;
  border: solid 0.5px #484b59;
}
.min {
  width: 145px;
  height: 30px;
  flex-grow: 0;
  margin: 0 0 0 12px;
  padding: 6px 12px;
  border-radius: 4px;
  border: solid 0.5px #484b59;
}
.select-cand {
  width: 28%;
  border: none;
  color: #484b59;
}
.sbj {
  width: 79%;
  height: 30px;
  flex-grow: 0;
  margin: 6px 0 0;
  color: #484b59;
}
.field-label {
  flex-grow: 0;
  margin: 0 0 0 0;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #484b59;
}
.save-btn {
  width: 120px;
  flex-grow: 0;
  margin: 0 0 0 12px;
  padding: 8px 42px;
  border-radius: 4px;
  border: solid 0.5px #2e93a1;
  background-color: #2e93a1;
  color: white;
}
.cancel-btn {
  flex-grow: 0;
  margin: 0 12px 0 0;
  padding: 7px 21px;
  border-radius: 2px;
  border: solid 0.5px #484b59;
}
.edit-btn {
  flex-grow: 0;
  margin: 0 5px 0 12px;
  padding: 7px 21px;
  border-radius: 4px;
  border: solid 0.5px #484b59;
  width: 120px;
  font-size: 14px;
  color: #484b59;
}
.saveAsTemplate {
  height: 18px;
  flex-grow: 0;
  margin: 0 0 0 8px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #484b59;
}
.disabled {
  width: 120px;
  height: 37px;
  flex-grow: 0;
  margin: 0 0 0 12px;
  padding: 8px 42px;
  border-radius: 4px;
  border: solid 0.5px gray;
  background-color: gray;
}
.error-message {
  color: red;
  margin-top: 5px;
}
.modal-heading {
  width: 121px;
  height: 21px;
  flex-grow: 0;
  margin: 0 16px 6px 0;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #484b59;
}
.close-btn {
  cursor: pointer;
  color: #2c2c2c;
}
.add-btn {
  width: 108px;
  height: 31px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-right: 1rem;
  margin-bottom: 1rem;
  padding: 7px 21px;
  border-radius: 2px;
  border: 1px solid #2e93a1;
  background-color: #2e93a1;
  color: white;
  float: right;
}
.campaign-inpt {
  width: 418px;
  height: 30px;
  flex-grow: 0;
  margin: 6px 0 0;
  padding-left: 2px;
  border-radius: 2px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.header {
  justify-content: space-between;
}
hr {
  margin: 0px 15px;
}
.p-component,
.p-component * {
  box-sizing: border-box;
  width: max-content !important;
}
.disabled-option {
  pointer-events: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  color: #969696 !important;
}
.disabled-click {
  cursor: not-allowed !important;
  pointer-events: none;
  background-color: #969696 !important;
}
.form-control {
  border: none;
}
.last-container {
  background-color: #f6f6f6;
  padding: 0px 15px 0 0;
}
.text-editor-in-edit-mode {
  padding: 0 0 0 1rem;
}
.placeholder {
  border-radius: 5px;
  border: 1px solid #d6dde6;
  width: 155px;
}
.subject-input {
}
.ai-text-gradient {
  background-image:
    linear-gradient(
      251deg,
      #c845ab 85%,
      #e24e7f 48%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.gradientbtn {
  padding: 8px 12px 8px 12px;
  border-radius: 4px;
  background-image:
    linear-gradient(
      49deg,
      #c845ab 13%,
      #e24e7f 60%);
  color: #ffffff;
}
.compose-btn {
  transition: all 0.3s ease;
  background: #ffffff;
  height: 38px;
  width: 38px;
  line-height: 1;
  font-size: 16px;
  padding: 0;
  border-radius: 100%;
}
.compose-btn:hover {
  background: #f6f6f6;
}
.c-shadow {
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
}
.with-animation {
  transition: all 0.3s ease;
}
.type-me {
}
.type-me::before {
  content: "";
  content: ""/"Write with GenAI!";
  alt: "Write with GenAI!";
  white-space: break-spaces;
  will-change: content;
  animation: typed-0 6.06s linear 1s 1 forwards, typed-0-final 1.7s linear 7.06s 1 forwards;
}
@keyframes typed-0-final {
  0%, 5.8823529412% {
    content: "W";
    content: "W"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  5.8833529412%, 11.7647058824% {
    content: "Wr";
    content: "Wr"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  11.7657058824%, 17.6470588235% {
    content: "Wri";
    content: "Wri"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  17.6480588235%, 23.5294117647% {
    content: "Writ";
    content: "Writ"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  23.5304117647%, 29.4117647059% {
    content: "Write";
    content: "Write"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  29.4127647059%, 35.2941176471% {
    content: "Write ";
    content: "Write "/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  35.2951176471%, 41.1764705882% {
    content: "Write w";
    content: "Write w"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  41.1774705882%, 47.0588235294% {
    content: "Write wi";
    content: "Write wi"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  47.0598235294%, 52.9411764706% {
    content: "Write wit";
    content: "Write wit"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  52.9421764706%, 58.8235294118% {
    content: "Write with";
    content: "Write with"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  58.8245294118%, 64.7058823529% {
    content: "Write with ";
    content: "Write with "/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  64.7068823529%, 70.5882352941% {
    content: "Write with G";
    content: "Write with G"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  70.5892352941%, 76.4705882353% {
    content: "Write with Ge";
    content: "Write with Ge"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  76.4715882353%, 82.3529411765% {
    content: "Write with Gen";
    content: "Write with Gen"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  82.3539411765%, 88.2352941176% {
    content: "Write with GenA";
    content: "Write with GenA"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  88.2362941176%, 94.1176470588% {
    content: "Write with GenAI";
    content: "Write with GenAI"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  94.1186470588%, 100% {
    content: "Write with GenAI!";
    content: "Write with GenAI!"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
}
@keyframes typed-0 {
  0%, 1.6491650165% {
    content: "W";
    content: "W"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  1.6501650165%, 3.299330033% {
    content: "Wr";
    content: "Wr"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  3.300330033%, 4.9494950495% {
    content: "Wri";
    content: "Wri"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  4.9504950495%, 6.599660066% {
    content: "Writ";
    content: "Writ"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  6.600660066%, 8.2498250825% {
    content: "Write";
    content: "Write"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  8.2508250825%, 9.899990099% {
    content: "Write ";
    content: "Write "/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  9.900990099%, 11.5501551155% {
    content: "Write w";
    content: "Write w"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  11.5511551155%, 13.200320132% {
    content: "Write wi";
    content: "Write wi"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  13.201320132%, 14.8504851485% {
    content: "Write wit";
    content: "Write wit"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  14.8514851485%, 16.500650165% {
    content: "Write with";
    content: "Write with"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  16.501650165%, 18.1508151815% {
    content: "Write with ";
    content: "Write with "/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  18.1518151815%, 19.800980198% {
    content: "Write with G";
    content: "Write with G"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  19.801980198%, 21.4511452145% {
    content: "Write with Ge";
    content: "Write with Ge"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  21.4521452145%, 23.101310231% {
    content: "Write with Gen";
    content: "Write with Gen"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  23.102310231%, 24.7514752475% {
    content: "Write with GenA";
    content: "Write with GenA"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  24.7524752475%, 26.401640264% {
    content: "Write with GenAI";
    content: "Write with GenAI"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  26.402640264%, 62.3752376238% {
    content: "Write with GenAI!";
    content: "Write with GenAI!"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  62.3762376238%, 63.695369637% {
    content: "Write with GenAI";
    content: "Write with GenAI"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  63.696369637%, 65.0155016502% {
    content: "Write with GenA";
    content: "Write with GenA"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  65.0165016502%, 66.3356336634% {
    content: "Write with Gen";
    content: "Write with Gen"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  66.3366336634%, 67.6557656766% {
    content: "Write with Ge";
    content: "Write with Ge"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  67.6567656766%, 68.9758976898% {
    content: "Write with G";
    content: "Write with G"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  68.9768976898%, 70.296029703% {
    content: "Write with ";
    content: "Write with "/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  70.297029703%, 71.6161617162% {
    content: "Write with";
    content: "Write with"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  71.6171617162%, 72.9362937294% {
    content: "Write wit";
    content: "Write wit"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  72.9372937294%, 74.2564257426% {
    content: "Write wi";
    content: "Write wi"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  74.2574257426%, 75.5765577558% {
    content: "Write w";
    content: "Write w"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  75.5775577558%, 76.896689769% {
    content: "Write ";
    content: "Write "/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  76.897689769%, 78.2168217822% {
    content: "Write";
    content: "Write"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  78.2178217822%, 79.5369537954% {
    content: "Writ";
    content: "Writ"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  79.5379537954%, 80.8570858086% {
    content: "Wri";
    content: "Wri"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  80.8580858086%, 82.1772178218% {
    content: "Wr";
    content: "Wr"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  82.1782178218%, 83.497349835% {
    content: "W";
    content: "W"/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
  83.498349835%, 100% {
    content: "";
    content: ""/"Write with GenAI!";
    alt: "Write with GenAI!";
  }
}
.ai-title {
}
.ai-title::before {
  content: "";
  content: ""/"with Gen AI or all on your own!";
  alt: "with Gen AI or all on your own!";
  white-space: break-spaces;
  will-change: content;
  animation: typed-1 4.98s linear 1s 1 forwards, typed-1-final 3.1s linear 5.98s 1 forwards;
}
@keyframes typed-1-final {
  0%, 3.2258064516% {
    content: "w";
    content: "w"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  3.2268064516%, 6.4516129032% {
    content: "wi";
    content: "wi"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  6.4526129032%, 9.6774193548% {
    content: "wit";
    content: "wit"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  9.6784193548%, 12.9032258065% {
    content: "with";
    content: "with"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  12.9042258065%, 16.1290322581% {
    content: "with ";
    content: "with "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  16.1300322581%, 19.3548387097% {
    content: "with G";
    content: "with G"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  19.3558387097%, 22.5806451613% {
    content: "with Ge";
    content: "with Ge"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  22.5816451613%, 25.8064516129% {
    content: "with Gen";
    content: "with Gen"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  25.8074516129%, 29.0322580645% {
    content: "with Gen ";
    content: "with Gen "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  29.0332580645%, 32.2580645161% {
    content: "with Gen A";
    content: "with Gen A"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  32.2590645161%, 35.4838709677% {
    content: "with Gen AI";
    content: "with Gen AI"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  35.4848709677%, 38.7096774194% {
    content: "with Gen AI ";
    content: "with Gen AI "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  38.7106774194%, 41.935483871% {
    content: "with Gen AI o";
    content: "with Gen AI o"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  41.936483871%, 45.1612903226% {
    content: "with Gen AI or";
    content: "with Gen AI or"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  45.1622903226%, 48.3870967742% {
    content: "with Gen AI or ";
    content: "with Gen AI or "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  48.3880967742%, 51.6129032258% {
    content: "with Gen AI or a";
    content: "with Gen AI or a"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  51.6139032258%, 54.8387096774% {
    content: "with Gen AI or al";
    content: "with Gen AI or al"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  54.8397096774%, 58.064516129% {
    content: "with Gen AI or all";
    content: "with Gen AI or all"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  58.065516129%, 61.2903225806% {
    content: "with Gen AI or all ";
    content: "with Gen AI or all "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  61.2913225806%, 64.5161290323% {
    content: "with Gen AI or all o";
    content: "with Gen AI or all o"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  64.5171290323%, 67.7419354839% {
    content: "with Gen AI or all on";
    content: "with Gen AI or all on"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  67.7429354839%, 70.9677419355% {
    content: "with Gen AI or all on ";
    content: "with Gen AI or all on "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  70.9687419355%, 74.1935483871% {
    content: "with Gen AI or all on y";
    content: "with Gen AI or all on y"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  74.1945483871%, 77.4193548387% {
    content: "with Gen AI or all on yo";
    content: "with Gen AI or all on yo"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  77.4203548387%, 80.6451612903% {
    content: "with Gen AI or all on you";
    content: "with Gen AI or all on you"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  80.6461612903%, 83.8709677419% {
    content: "with Gen AI or all on your";
    content: "with Gen AI or all on your"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  83.8719677419%, 87.0967741935% {
    content: "with Gen AI or all on your ";
    content: "with Gen AI or all on your "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  87.0977741935%, 90.3225806452% {
    content: "with Gen AI or all on your o";
    content: "with Gen AI or all on your o"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  90.3235806452%, 93.5483870968% {
    content: "with Gen AI or all on your ow";
    content: "with Gen AI or all on your ow"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  93.5493870968%, 96.7741935484% {
    content: "with Gen AI or all on your own";
    content: "with Gen AI or all on your own"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  96.7751935484%, 100% {
    content: "with Gen AI or all on your own!";
    content: "with Gen AI or all on your own!"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
}
.ai-title::after {
  content: "\200b";
  position: relative;
  display: inline-block;
  padding-right: 2px;
  border-right: 2px solid currentColor;
  white-space: nowrap;
  animation: typed-1-caret 0.75s linear 1s infinite forwards;
}
@keyframes typed-1 {
  0%, 2.0070321285% {
    content: "w";
    content: "w"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  2.0080321285%, 4.015064257% {
    content: "wi";
    content: "wi"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  4.016064257%, 6.0230963855% {
    content: "wit";
    content: "wit"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  6.0240963855%, 8.0311285141% {
    content: "with";
    content: "with"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  8.0321285141%, 10.0391606426% {
    content: "with ";
    content: "with "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  10.0401606426%, 12.0471927711% {
    content: "with G";
    content: "with G"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  12.0481927711%, 14.0552248996% {
    content: "with Ge";
    content: "with Ge"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  14.0562248996%, 16.0632570281% {
    content: "with Gen";
    content: "with Gen"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  16.0642570281%, 18.0712891566% {
    content: "with Gen ";
    content: "with Gen "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  18.0722891566%, 20.0793212851% {
    content: "with Gen A";
    content: "with Gen A"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  20.0803212851%, 63.8544216867% {
    content: "with Gen AI";
    content: "with Gen AI"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  63.8554216867%, 65.4608473896% {
    content: "with Gen A";
    content: "with Gen A"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  65.4618473896%, 67.0672730924% {
    content: "with Gen ";
    content: "with Gen "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  67.0682730924%, 68.6736987952% {
    content: "with Gen";
    content: "with Gen"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  68.6746987952%, 70.280124498% {
    content: "with Ge";
    content: "with Ge"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  70.281124498%, 71.8865502008% {
    content: "with G";
    content: "with G"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  71.8875502008%, 73.4929759036% {
    content: "with ";
    content: "with "/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  73.4939759036%, 75.0994016064% {
    content: "with";
    content: "with"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  75.1004016064%, 76.7058273092% {
    content: "wit";
    content: "wit"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  76.7068273092%, 78.312253012% {
    content: "wi";
    content: "wi"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  78.313253012%, 79.9186787149% {
    content: "w";
    content: "w"/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
  79.9196787149%, 100% {
    content: "";
    content: ""/"with Gen AI or all on your own!";
    alt: "with Gen AI or all on your own!";
  }
}
@keyframes typed-1-caret {
  75% {
    border-color: transparent;
  }
}
.form-control:focus {
  border-color: #2e93a1;
  box-shadow: 0 0 0 0.2rem rgba(46, 147, 161, 0.25);
}
::ng-deep .timezone-option .mat-option-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.tz-offset {
  margin-left: auto;
  color: #6b7280;
  font-size: 12px;
}
.email-campaign-highlight {
  background-color: rgb(250, 204, 204);
  padding: 2px 4px;
  border-radius: 2px;
}
.timezon-drop {
  position: absolute;
  right: 18px;
  top: 11px;
}
/*# sourceMappingURL=edit-panel.component-E7EA54V2.css.map */
